import { render } from "./Brands.vue?vue&type=template&id=0d67ed82"
import script from "./Brands.vue?vue&type=script&lang=ts"
export * from "./Brands.vue?vue&type=script&lang=ts"
script.render = render

export default script